'use strict';

var React = require('react');

var SvgReceiptDollarFilledIcon = function SvgReceiptDollarFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.142 16.934a1 1 0 0 1-.642-.934v-11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v11a1 1 0 0 1-1.743.669l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.486 0l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.101.265Zm4.358-11.684a.75.75 0 0 1 1.5 0v.5h.75a.75.75 0 0 1 0 1.5h-2.375a.625.625 0 1 0 0 1.25h1.25a2.125 2.125 0 0 1 0 4.25h-.125v.5a.75.75 0 0 1-1.5 0v-.5h-.75a.75.75 0 0 1 0-1.5h2.375a.625.625 0 1 0 0-1.25h-1.25a2.125 2.125 0 0 1 0-4.25h.125v-.5Z"
  }));
};
SvgReceiptDollarFilledIcon.displayName = "ReceiptDollarFilledIcon";

exports.SvgReceiptDollarFilledIcon = SvgReceiptDollarFilledIcon;
